import { paths } from 'src/routes/paths';
import axios, { endpoints } from 'src/utils/axios';
import handleOKRequest from 'src/components/grids/generic-grid/handleOKRequest';
import handleBadRequest from 'src/components/grids/generic-grid/handleBadRequest';
import { createAsyncThunk } from '@reduxjs/toolkit';

//Modificar de acuerdo a la lógica de la acción
export const marcarPlanificadoProyectoF = createAsyncThunk(
  'proyectoForm/marcarPlanificadoProyectoF',
  async ({ data }: { data: any }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        endpoints.actions.marcarPlanificadoProyectoF,
        data
      );
      handleOKRequest(response, 'Acción ejecutada correctamente.');
      return response.data;
    } catch (error) {
      handleBadRequest(error);
      return rejectWithValue(
        error.response?.data || 'Error al ejecutar la acción.'
      );
    }
  }
);

//Modificar de acuerdo a la lógica de la acción
export const marcarEnProcesoProyectoF = createAsyncThunk(
  'proyectoForm/marcarEnProcesoProyectoF',
  async ({ data }: { data: any }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        endpoints.actions.marcarEnProcesoProyectoF,
        data
      );
      handleOKRequest(response, 'Acción ejecutada correctamente.');
      return response.data;
    } catch (error) {
      handleBadRequest(error);
      return rejectWithValue(
        error.response?.data || 'Error al ejecutar la acción.'
      );
    }
  }
);

//Modificar de acuerdo a la lógica de la acción
export const marcarDemoradoProyectoF = createAsyncThunk(
  'proyectoForm/marcarDemoradoProyectoF',
  async ({ data }: { data: any }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        endpoints.actions.marcarDemoradoProyectoF,
        data
      );
      handleOKRequest(response, 'Acción ejecutada correctamente.');
      return response.data;
    } catch (error) {
      handleBadRequest(error);
      return rejectWithValue(
        error.response?.data || 'Error al ejecutar la acción.'
      );
    }
  }
);

//Modificar de acuerdo a la lógica de la acción
export const marcarFinalizadoProyectoF = createAsyncThunk(
  'proyectoForm/marcarFinalizadoProyectoF',
  async ({ data }: { data: any }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        endpoints.actions.marcarFinalizadoProyectoF,
        data
      );
      handleOKRequest(response, 'Acción ejecutada correctamente.');
      return response.data;
    } catch (error) {
      handleBadRequest(error);
      return rejectWithValue(
        error.response?.data || 'Error al ejecutar la acción.'
      );
    }
  }
);
